<div class="component-container flex flex-col md:flex-row flex-wrap justify-between items-center w-full">
  <div
    *ngIf="selectedUserLoading; else filter"
    class="input w-full md:w-[20%]"
  >
    <app-shimmer-loader
      [count]="1"
      [theme]="{'height': '5rem'}"
      appearance="line"
    />
  </div>
  <ng-template #filter>
    <app-search-on-select
      (checkForErrors)="checkForErrors($event)"
      (onNextPage)="clinicsOnNextPage()"
      *ngIf="role === roles['superAdmin'] && !selectedUserRole && !selectedUserLoading; else group"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['clientId']"
      [hasNext]="clinicFilterList.hasNext"
      [loading]="clinicFilterList.loading"
      [options]="clinicFilterList.list"
      [parentFormGroup]="form"
      class="input w-full md:w-[20%]"
      controlName="clinic"
      filterControlName="searchClinic"
      label="Organization"
      optionsPanelClassName="clients-dropdown"
      placeholder="Select all that apply"
      type="small"
    ></app-search-on-select>
    <ng-template #group>
      <app-search-on-select
        (checkForErrors)="checkForErrors($event)"
        (onNextPage)="groupsOnNextPage()"
        [enableClearSelection]="true"
        [enableMultiple]="true"
        [error]="errorMessages['groupId']"
        [hasNext]="groupFilterList.hasNext"
        [loading]="groupFilterList.loading"
        [options]="groupFilterList.list"
        [parentFormGroup]="form"
        class="input w-full md:w-[20%]"
        controlName="group"
        filterControlName="searchGroup"
        label="Group"
        optionsPanelClassName="groups-dropdown"
        placeholder="Select all that apply"
        type="small"
      />
    </ng-template>
  </ng-template>

  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableClearSelection]="true"
    [enableMultiple]="true"
    [error]="errorMessages['role']"
    [loading]="rolesFilterData?.loading"
    [options]="rolesFilterData?.list"
    [parentFormGroup]="form"
    class="input w-full md:w-[20%]"
    controlName="role"
    label="Role"
    placeholder="Select all that apply"
    type="small"
  />
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableClearSelection]="true"
    [enableMultiple]="true"
    [error]="errorMessages['status']"
    [loading]="statusFilterList?.loading"
    [options]="statusFilterList?.list"
    [parentFormGroup]="form"
    class="input w-full md:w-[20%]"
    controlName="status"
    label="Status"
    placeholder="Select all that apply"
    type="small"
  />

  <hr class="vertical hidden md:block">

  <app-text-input
    (checkForErrors)="checkForErrors($event)"
    (handleSuffixClick)="apply()"
    [error]="errorMessages['search']"
    [parentFormGroup]="form"
    class="input w-full md:w-[20%] search-input"
    controlName="search"
    label="Search"
    placeholder="Search User"
    suffixIcon="search"
    type="small"
  />

  <hr class="vertical hidden md:block">

  <app-primary-button
    (handleClick)="apply()"
    [isDisabled]="!form.dirty"
    class="btn w-full md:w-[10%] md:mt-[1.5rem] mb-[1.5rem]"
    type="small"
  >
    Apply
  </app-primary-button>
</div>
